import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: theme.shadows[8],
    transform: "translateY(-4px)",
  },
}));

const MetricValue = styled(Typography)(({ theme, color }) => ({
  fontSize: "2rem",
  fontWeight: "bold",
  color: color || theme.palette.primary.main,
  marginBottom: "0.5rem",
}));

const MetricLabel = styled(Typography)({
  fontSize: "0.875rem",
  color: "#666",
  marginBottom: "1rem",
});

const MetricCard = ({ label, value, unit = "", isLoading, onClick }) => {
  return (
    <StyledCard
      onClick={onClick}
      sx={{ opacity: isLoading ? 0.6 : 1 }}
    >
      <CardContent>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "120px",
            }}
          >
            <CircularProgress size={40} />
          </Box>
        ) : (
          <>
            <MetricLabel variant="body2">{label}</MetricLabel>
            <MetricValue>
              {typeof value === "number" ? value.toLocaleString() : value}
              {unit && <span style={{ fontSize: "1rem" }}>{unit}</span>}
            </MetricValue>
          </>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default MetricCard;
